<template>
    <div class="subPage">
        <div v-if="selected == 1" class="posterContainer">
            <div class='posterContainer2'>
                <img alt="img" :src="friendEnvPoster[selectedWxFriendEnv].poster" :style='autoHeight' />
            </div>
            <div class="fixed">
                <!-- 文字提示 -->
                <p class="tip">您当前选择了朋友圈渠道请长按保存发再发朋友圈</p>
                <!-- 选择区域 -->
                <div class="container">
                    <div
                        v-for="(item, index) in friendPoster" :key="`${index}wx`"
                        :class="selectedWxFriendEnv === index ? 'select' : 'smallImgContainer'"
                        @click="() => selectWxFriendEnv(index)"
                    >
                        <img :src="item.templateTitle" />
                    </div>
                </div>
            </div>
        </div>
        <!--  -->
        <!--  -->
        <div v-if="selected == 2" class="posterContainer">
            <div class='posterContainer2'>
                <img :src="friendPoster[selectedWxFriend].poster" :style='autoHeight'>
            </div>
            <div class="fixed">
                <!-- 文字提示 -->
                <p class="tip">您当前选择了好友渠道请长按发送给好友</p>
                <!-- 选择区域 -->
                <div class="container">
                    <div
                        v-for="(item, index) in friendPoster" :key="`${index}monment`"
                        :class="selectedWxFriend === index ? 'select' : 'smallImgContainer'"
                        @click="() => selectWxFriend(index)"
                    >
                        <img :src="item.templateTitle" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  props: ['selected', 'friendPoster', 'friendEnvPoster'],
  name: 'Detail',
  created() {
      this.autoHeight = {
          height: `${window.innerHeight - 150}px`
      }
  },
  data() {
        return {
            selectedWxFriendEnv: 0,
            selectedWxFriend: 0,
            autoHeight: {
                height: 'unset'
            }
        }
  },
  methods: {
      selectWxFriendEnv: function(value) {
          this.selectedWxFriendEnv = value;
      },
      selectWxFriend: function(value) {
          this.selectedWxFriend = value;
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.posterContainer {
    height: unset;
}
.posterContainer img {
    border-radius: 5px;
    margin: 5% 12%;
}
.tip {
    position: relative;
    margin-top: -.5rem;
    text-align: center;
    padding: .1rem;
    background: #DEFFFC;
    color: #009688;
    font-size: .14rem;
}
.container {
    z-index: 9999999;
    justify-content: space-around;
    overflow: auto;
    white-space: nowrap;
}
.container div {
    display: inline-block;
}
.smallImgContainer {
    margin: .1rem;
    width: 45px;
    height: 45px;
}
.smallImgContainer img {
    width: 100%;
    height: 100%;
}
.posterContainer2 {
	display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -0.3rem;
    /*text-align: center;
    position: relative;
    top: -.5rem;*/
}
.posterContainer2 img {
    
}
.subPage {
    margin-bottom: 0;
}
.select {
    margin: .1rem;
    width: 45px;
    height: 45px;
}
.select::after {
    position: relative;
    bottom: 13px;
    margin-left: -40px;
    display: inline-block;
    content: url('../../../static/img/confirm.svg');
}
.select img {
    width: 100%;
    height: 100%;
}
.fixed {
    bottom: 0;
    position: absolute;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/userPosterElement/Detail.vue